export const VEHICLE_TYPES = {
  VAN: 'van',
  BOX_VAN: 'box-van',
  RIGID_TRUCK: 'rigid',
  TRACTOR_UNIT: 'tractor_unit',
  TRAILER: 'trailer',
  SEMI_TRAILER: 'semi_trailer',
};
